import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./ServiceDetail.css";

const serviceData = {
  flights: {
    title: "Flights",
    description:
      "Book domestic and international flights with the best deals and seamless booking experience. Enjoy flexible bookings and excellent customer service.",
    img: "/Images/flight.jpeg",
    btn: "Become B2B Partner",
    content: [
      {
        heading: "Why Choose Our Flights",
        paragraphs: [
          "We offer flexible booking options for both domestic and international flights, ensuring that your travel plans remain uninterrupted even when things change.",
          "Our top-notch customer service team is available 24/7 to assist with bookings, cancellations, and travel queries, providing peace of mind for all travelers.",
          "Exclusive deals with trusted airlines allow you to get the best prices without compromising on comfort or convenience.",
        ],
      },
      {
        heading: "Seamless Experience",
        paragraphs: [
          "From the moment you search for a flight to boarding the plane, our platform ensures a smooth and hassle-free process.",
          "Real-time flight updates and notifications keep you informed about any changes, delays, or important announcements.",
          "With secure payment options and clear booking confirmations, your travel experience is both reliable and convenient.",
        ],
      },
    ],
    highlights: [
      "All leading LCC & full-service domestic carriers via single XML",
      "Selling NET fares across the Globe",
      "Local country payment options available",
      "24/7 customer and technical support",
      "Specialization in SOTO ticketing",
      "Real-time access to competitive fares",
      "Real-time itinerary push using the Roamer App",
    ],
    icon: "✈️",
  },
  hotels: {
    title: "Hotels",
    description:
      "Find and book hotels worldwide with exclusive discounts, trusted reviews, and top amenities. Perfect stays for business or leisure.",
    img: "https://media.istockphoto.com/id/472899538/photo/downtown-cleveland-hotel-entrance-and-waiting-taxi-cab.jpg?s=612x612&w=0&k=20&c=rz-WSe_6gKfkID6EL9yxCdN_UIMkXUBsr67884j-X9o=",
    btn: "Become B2B Partner",
    content: [
      {
        heading: "Comfortable Stays",
        paragraphs: [
          "Our hotels provide comfort, safety, and modern amenities to make your stay memorable.",
          "From cozy rooms to luxurious suites, we offer options suitable for both business and leisure travelers.",
          "Enjoy well-maintained facilities, attentive service, and prime locations near key attractions or business hubs.",
        ],
      },
      {
        heading: "Exclusive Offers",
        paragraphs: [
          "We provide access to exclusive discounts, special promotions, and loyalty rewards for frequent travelers.",
          "Booking through our platform ensures transparent pricing with no hidden fees, making your stay affordable and stress-free.",
          "Special packages for families, couples, or business travelers allow you to get more value while enjoying premium experiences.",
        ],
      },
    ],
    highlights: [
      "Inventory of over 1 MN+ unique hotels, apartments, vacation homes",
      "Advance purchase / non-refundable / discounted rates available",
      "Real-time availability & competitive rates",
      "Booking re-confirmation prior to check-in",
      "Payment options in 55+ currencies",
      "Operational support in 11+ languages",
      "Global chains, regional chains, local chains & independents",
    ],
    icon: "🏨",
  },
  packages: {
    title: "Packages",
    description:
      "Explore curated holiday packages that include flights, stays, and activities for a hassle-free vacation. Save time and money with bundled deals.",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZUIWKrXEuWwnVJkKKG2hQyu7Aja-vBqq__g&s",
    btn: "Become B2B Partner",
    content: [
      {
        heading: "Curated Packages",
        paragraphs: [
          "Our travel packages are carefully designed to provide a complete and memorable vacation experience.",
          "Each package includes flights, comfortable accommodations, and exciting activities at your destination.",
          "Whether it's a family holiday, romantic getaway, or adventure trip, we have packages tailored to every traveler.",
        ],
      },
      {
        heading: "Save Time & Money",
        paragraphs: [
          "Bundling flights, hotels, and activities in one package allows you to save both time and money.",
          "Our packages often include exclusive deals and discounts not available when booking separately.",
          "Enjoy the convenience of a single booking platform for a hassle-free travel experience from start to finish.",
        ],
      },
    ],
    highlights: [
      "Real-time package prices with availability",
      "Selection of various hotels & sightseeing options",
      "Instant package confirmation",
      "Never miss attractive deals & offers",
      "No back & forth on offline quotes & confirmations",
      "No hidden costs",
      "Create your own marketing flyers & many more features",
    ],
    icon: "🏖️",
  },
};

const ServiceDetail = () => {
  const { type } = useParams();
  const service = serviceData[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  if (!service) {
    return (
      <div className="service-detail-page">
        <h2>Service not found</h2>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      {/* Hero */}
      <section className="service-detail-hero catchy-hero">
        <div className="hero-accent accent1"></div>
        <div className="hero-accent accent2"></div>

        <div className="hero-left service-detail-text service-animate-slide">
          <h1>{service.title}</h1>
          <p>{service.description}</p>
          <a
            href="https://flyabasin.com/agent-registration"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="hero-badge service-animate-bounce">
              ✨ {service.btn}
            </div>
          </a>
        </div>
        <div className="hero-right service-detail-image service-animate-fade">
          <img src={service.img} alt={service.title} />
        </div>
      </section>

      {/* Content Section Below Hero */}
      <section className="service-detail-content">
        {service.content.map((item, index) => (
          <div className="service-detail-item service-animate-fade" key={index}>
            <h2>{item.heading}</h2>
            {item.paragraphs.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        ))}

        {/* Highlights */}
        {service.highlights && (
          <div className="service-highlights service-animate-fade">
            <h2>Key Highlights</h2>
            <div className="highlights-grid">
              {service.highlights.map((point, i) => (
                <div
                  className="highlight-card service-animate-fade"
                  key={i}
                  style={{ animationDelay: `${i * 0.2}s` }}
                >
                  <span className="highlight-icon">{service.icon}</span>
                  <p>{point}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
            {/* CTA */}
      <div className="serviceDetails-cta">
        <a  href="https://flyabasin.com/agent-registration" target="_blank" rel="noopener noreferrer">
          <button>Agent Partner</button>
        </a>
      </div>
    </div>
  );
};

export default ServiceDetail;
